// extracted by mini-css-extract-plugin
export default {"container":"ViewStory_container__kln7E","inner":"ViewStory_inner__rWn5H"};